/**
 * Dirección pública de la guía para los enlaces copiados.
 * Todos los botones "Copiar enlace" comparten este dominio + la ruta legible,
 * aunque se copie desde la vista previa de Magic Patterns.
 */
export const PUBLIC_SITE_URL = 'https://guia.mu-vanguard.com'
